export default __webpack_public_path__ + "static/media/gucci_bloom_lowdef.486c959b.png";